<div class="auth-settings-root">

	<ad-auth-settings></ad-auth-settings>

	<hr style="margin-top: 20px; margin-bottom: 20px;" />

	<saml-auth-settings></saml-auth-settings>

	<hr style="margin-top: 20px; margin-bottom: 20px;" />

	<gw-auth-settings></gw-auth-settings>

</div>